import { useImperativeHandle } from 'react'
import { getComposerPlainText } from './composerSerialize'

export function useComposerImperativeHandle(ref, editor) {
  useImperativeHandle(
    ref,
    () => ({
      getEditor: () => editor,
      insertPlainText(text) {
        if (editor && !editor.isDestroyed && text) {
          editor.chain().focus().insertContent(text).run()
        }
      },
      focusEnd() {
        if (editor && !editor.isDestroyed) {
          editor.chain().focus('end').run()
        }
      },
      clearDocument() {
        if (editor && !editor.isDestroyed) {
          editor.commands.clearContent(true)
        }
      },
      setPlainContent(text) {
        if (editor && !editor.isDestroyed) {
          editor.commands.setContent({
            type: 'doc',
            content: [{ type: 'paragraph', ...(text ? { content: [{ type: 'text', text }] } : {}) }],
          })
        }
      },
      getPlainText() {
        return getComposerPlainText(editor)
      },
    }),
    [editor],
  )
}
